import { module } from "angular";
import { LoadingComponent } from "./LoadingComponent";

module("mmGui").component("mmLoading", new LoadingComponent());
